import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    subTitle: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    navbarBg: p => p.tertiaryDark,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`,
    lightBackground: p => p.tertiaryExtraLight
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    subTitle: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    navbarBg: p => p.tertiaryLight,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`,
    lightBackground: p => p.tertiaryExtraLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    subTitle: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    navbarBg: p => p.tertiaryExtraLight,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`,
    lightBackground: p => p.tertiaryExtraLight
  }
}
